<div id="login-container">
  <div id="page-container">
    <div class="login">
      <div class="card-container">
        <div class="row m-0">
          <div class="content-container col col-lg-5">
            <div class="logo-container">
              <div class="d-flex justify-content-start align-items-center">
                <img class="s-logo" src="assets/images/login/sweet-logo.png" />
              </div>
            </div>
            <div class="sign-in-text">
          <span>
            {{ 'login.dontHaveAccount' | translate }}
            <button class="btn btn-link btn-sm m-0 p-0" (click)="navigateToRegister()">{{ 'login.register' | translate }}</button>
            {{ 'login.getStart' | translate }}
          </span>
            </div>

            <form class="js-validation-signin px-30 login-form" [formGroup]="loginForm">
              <mat-form-field class="w-100" appearance="standard">
                <mat-label>{{ 'login.username' | translate }}</mat-label>
                <input matInput formControlName="email" name="login-username" />
                <i class="fa fa-user login-form-icon"></i>
              </mat-form-field>
              <mat-form-field class="w-100" appearance="standard">
                <mat-label>{{ 'login.password' | translate }}</mat-label>
                <input matInput [type]="inputPasswordType" formControlName="password" id="login-password"
                       name="login-password" />
                <i
                  class="fa login-form-icon fa-eye{{ this.inputPasswordType === 'password' ? '' : '-slash' }} password-icon"
                  (click)="onShowPassword()"></i>
              </mat-form-field>
              <div class="row m-0">
                <button class="btn login-btn btn-success" [disabled]="loginForm.invalid || isLoading"
                        (click)="onLoginClick()">
                  {{ 'login.signIn' | translate }}
                </button>
              </div>
              <div class="alert alert-danger login-error-alert" role="alert" *ngIf="isError">
                <strong>{{ errorMessage }}!</strong> {{ 'login.tryAgain' | translate }}
              </div>
              <div class="d-flex justify-content-between mt-4">
                <div class="forgot-password" (click)="resetPassword()">{{ 'login.forgotPassword' | translate }}</div>
              </div>
            </form>
            <div class="troubles-info">
              <span class="mr-1">{{ 'login.troublesQuestion' | translate }}</span>
              <a href="https://sweetanalytics.com/contact-us/" target="_blank">{{ 'login.noAccountContact' | translate
                }}</a>
            </div>
          </div>
          <div class="image-container col-lg-7 p-0 d-none d-lg-block">
            <img class="login-image" src="assets/images/login/sweet-login.png" alt="" />
            <div class="image-text">
              <span class="image-text-title">{{ 'login.welcome' | translate }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>
</div>
